import { createContext, type Dispatch, type SetStateAction, type ReactNode, type FC, useState } from 'react';

interface DownloadedContextProps {
  downloadedState: boolean;
  setDownloadedState: Dispatch<SetStateAction<boolean>>;
}

export const DownloadedContext = createContext<DownloadedContextProps>({
  downloadedState: false,
  setDownloadedState: () => null,
});

export const DownloadedProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [downloadedState, setDownloadedState] = useState<boolean>(false);
  return (
    <DownloadedContext.Provider value={{ downloadedState, setDownloadedState }}>{children}</DownloadedContext.Provider>
  );
};
